/**
 * media: how a chart point of each widget maps back to the rows behind it,
 * for the conversations drill-down. Same filtering as the widget's loader
 * (own brand → chips → coverage).
 */
import { bucketStart } from '@/lib/analytics/buckets';
import { isoToMs } from '@/lib/analytics/dates';

import { mediaScope } from '../widgets/media';
import { byCategory } from './mentions';
import type { DrillResolver, DrillResolvers } from './types';

const stories = (query: Parameters<DrillResolver>[1]) => mediaScope(query).stories;

export const mediaDrillResolvers: DrillResolvers = {
  'top-media-outlets': byCategory(stories, 'outlet'),
  /* A week of the share plot: every story that week, whichever line was clicked. */
  'media-sentiment-over-time': (ref, query) => {
    const rows = stories(query);
    const bucket = ref.bucket;
    if (!bucket) return rows;
    const start = isoToMs(bucket.start);
    return rows.filter((row) => bucketStart(row.day, bucket.unit) === start);
  },
};
